// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1oq2O","label":"CategoryService_label__30JtN","location":"CategoryService_location__3Z5NN"};